import db from "@/plugins/dexie";
import moment from "moment-timezone";

export default {
  namespaced: true,

  state: {
    list: [],
    cache_produtoMap: new Map(),
    cache_clienteMap: new Map(),
    cache_produto: [],
    cache_cliente: [],
    cache_grupo: [],
    cache_ordemservico: [],
    cache_ordemservicoitem: [],
    arrayDataAtualizacao: [],
    primeiroUpdate: false,
  },

  getters: {
    list: (state) => state.list,
    arraydata: (state) => {
      return state.arrayDataAtualizacao;
    },
    primeiroUpdate: (state) => {
      return state.primeiroUpdate;
    }
  },

  // NUNCA ALTERAR state DIRETAMENTE EM ACTIONS
  actions: {

    async esvaziarCache({ commit }, payload) {
      if(payload.att){
        const lastItem = await db[payload.tabela].orderBy(`${payload.att}`).filter(item => item[payload.att] !== null).last();
        if (lastItem) {
          const dataatt = lastItem[payload.att];
          commit('SET_ATUALIZA_DATA', {tabela: payload.tabela, data: moment.utc(dataatt).format('YYYY-MM-DD HH:mm:ss.SSS')})
        }
      }
      commit('EMPTY_CACHE', payload.tabela);
    },

    async setCache({ commit }, payload) {
      commit('SET_CACHE', payload);
    },

    async pushCache({ commit, state }, payload) {
      if (state[`cache_${payload.tabela}`].length > 0) {
        commit('PUSH_CACHE', payload);
      }
    },

    async getCache({ state }, tabela){
  const arr = state[`cache_${tabela}`];
  // Retorna o array quando há dados, caso contrário retorna null (compatível com checagens existentes)
  return Array.isArray(arr) && arr.length > 0 ? arr : null;
    },
    async getState({ state }, tabela){
     return state[`cache_${tabela}`]
    },

    async atualizaData({ commit }, atualizar) {
      commit('SET_ATUALIZA_DATA', atualizar);
    },

    async primeiroUpdate({ commit }, estado) {
      commit('SET_PRIMEIRO_UPDATE', estado);
    },

    async reloadCache({ commit} , tabela) {
      let dados;
      if (tabela === 'ordemservico') dados = await db[tabela].reverse().sortBy('orsdatacadastro');
      else dados = await db[tabela].toArray();
      commit('SET_CACHE', {tabela, dados});
    }
  },

  // APENAS O MUTATION FAZ ALTERAÇÕES NO STATE
  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
    EMPTY_CACHE(state, tabela) {
      state[`cache_${tabela}`] = [];
    },
    SET_CACHE(state, payload) {
      state[`cache_${payload.tabela}`] = payload.dados ?? [];
      // Protege contra payload.dados que não sejam arrays (evita "map is not a function")
      if (Array.isArray(payload.dados)) {
        if (payload.tabela === 'produto') state.cache_produtoMap = new Map(payload.dados.map((item) => [item.procodigointerno, item]));
        if (payload.tabela === 'cliente') state.cache_clienteMap = new Map(payload.dados.map((item) => [item.cliidcliente, item]));
      } else {
        // Garante que os Maps estejam vazios quando dados inválidos forem recebidos
        if (payload.tabela === 'produto') state.cache_produtoMap = new Map();
        if (payload.tabela === 'cliente') state.cache_clienteMap = new Map();
      }
    },
    PUSH_CACHE(state, payload) {
      state[`cache_${payload.tabela}`].push(...payload.novosItens);
    },
    SET_CACHE_ARRAYDATA(state, arraydata) {
      state.arrayDataAtualizacao = arraydata ?? [];
    },
    SET_ATUALIZA_DATA(state, atualizar) {
      state.arrayDataAtualizacao.map((item, index) => {
        if (item.tabelaApp === atualizar.tabela) {
          state.arrayDataAtualizacao[index].data = atualizar.data;
        }
      })
    },
    SET_PRIMEIRO_UPDATE(state, estado) {
      state.primeiroUpdate = estado ?? false;
    }
  },
};
